import { render, staticRenderFns } from "./LicensePlateTemplate.vue?vue&type=template&id=20c5cd57&scoped=true&"
import script from "./LicensePlateTemplate.vue?vue&type=script&lang=js&"
export * from "./LicensePlateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LicensePlateTemplate.vue?vue&type=style&index=0&id=20c5cd57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5cd57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
